<template>
  <section id="lessor" class="anchor-section">
    <div class="section-header">
      <a-space align="center">
        <div class="title_icon"></div>
        <div class="ant-descriptions-title section-title">出租方基本情况</div>
      </a-space>
    </div>

    <a-descriptions bordered :column="1" class="fixed-13-desc">
      <a-descriptions-item :span="3">
        <template slot="label">
          <span class="desc-label-text">出租方名称（姓名）</span>
        </template>
        {{bidBaseInfo.lessorName}}
      </a-descriptions-item>

      <a-descriptions-item :span="3">
        <template slot="label">
          <span class="desc-label-text">出租方所属集团</span>
        </template>
        {{bidBaseInfo.groupDepartmentName}}
      </a-descriptions-item>

      <a-descriptions-item :span="3">
        <template slot="label">
          <span class="desc-label-text">出租方监管部门</span>
        </template>
        {{bidBaseInfo.regulatoryAuthorities}}
      </a-descriptions-item>

      <a-descriptions-item :span="3">
        <template slot="label">
          <span class="desc-label-text">受委托进行招租活动</span>
        </template>
        {{bidBaseInfo.hasEntrustRent == 1 ? "是" : "否"}}
      </a-descriptions-item>
    </a-descriptions>
  </section>
</template>

<script>
export default {
  props: {
    bidBaseInfo: {
      type: Object,
      default: () => null,
    },
  },
};
</script>

<style scoped>
.anchor-section {
  scroll-margin-top: 120px;
}

.section-header {
  margin: 30px 4px 14px;
}

.section-title {
  font-size: 16px;
  margin-bottom: 0;
}

.title_icon {
  width: 8px;
  height: 26px;
  margin-right: 10px;
  background: #007aff;
  border-radius: 0 3px 3px 0;
}

.desc-label-text {
  font-weight: 500;
}


.fixed-13-desc /deep/ .ant-descriptions-item-label {
  width: 25%;
}

.fixed-13-desc /deep/ .ant-descriptions-item-content {
  width: 75%;
  background: white;
}

</style>